import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('management-reports-blueprints', storeModule.createStoreModule('management-reports-blueprints'))
